import { RestrictedAccountObjectApiFacade } from "../restricted-account-object/restricted-account-object.api-facade";
import { Lookup } from "./lookup.model";
import { Observable } from "rxjs/Observable";
import { ApiRequestOptions } from "../../../core/services/api/request-options";

export class LookupApiFacade extends RestrictedAccountObjectApiFacade<Lookup> {

    get(accountId: string, id: string, options?: ApiRequestOptions): Observable<Lookup> {
        return this.GET(`/accounts/${accountId}/lookups/${id}`, options)
            .map(object => new Lookup(object));
    }

    getAll(accountId: string, options?: ApiRequestOptions): Observable<Array<Lookup>> {
        return this.CGET(`/accounts/${accountId}/lookups`, options)
            .map(objects => objects.map(object => new Lookup(object)));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/lookup/lookup.api-facade.ts